import React from 'react';
import {DonorTypes} from "../types";

interface LookupUrlProps {
    donorType: DonorTypes;
}

const LookupUrl: React.FC<LookupUrlProps> = ({donorType}) => {
    switch (donorType) {
        case DonorTypes.MEETING:
        case DonorTypes.INTERGROUP:
            return (
                <a href={donorType === DonorTypes.MEETING ? '/meeting-search/' : '/intergroup-listing/'}
                   target="_blank"
                   rel="noreferrer">
                    Lookup your {donorType.toLowerCase()}
                </a>
            );
        default:
            return null;
    }
};

export default LookupUrl;
